
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".67","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M22.334 4.667v12l-4-3-4 3v-12","stroke":"#56BFC7"}}),_c('path',{attrs:{"d":"M6.333 27.667a2.988 2.988 0 013-3h17v-20h-17a2.987 2.987 0 00-3 3v20zM6.333 27.667v1h18","stroke":"#fff"}})])])
          )
        }
      }
    